import * as React from 'react';

import { ISnackbarContext } from '.';

export const SnackbarContext = React.createContext<ISnackbarContext | undefined>(
    undefined
);
